import React from 'react';
import InternalRedirect from 'react-router-dom/Redirect';

export default class extends React.Component {
  static propTypes = InternalRedirect.propTypes;
  render() {
    const { external, to } = this.props;
    if (typeof to === 'string' && (external || /http(s)?:\/\//.test(to))) {
      window.location.href = to;
      return null;
    }
    return <InternalRedirect {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Redirect/index.js